// What a Boba Bash is, in the program's own words. The landing page says it
// once and every city page inherits it, so an organizer who writes nothing
// still has the right answer on their page - and one who does write something
// replaces this rather than adding a second, different explanation.
export default function AboutBoba() {
  return (
    <>
      <p>
        An afternoon in a boba shop with a room full of other teenagers. You
        bring a laptop and we cover the drinks. Three to five hours later you've
        built something, and everyone shows the room what they made.
      </p>
      <p>
        It's <span className="text-ink font-bold">not a hackathon</span>. Nobody
        judges it and there's no prize. You don't need to have written a line of
        code before, which is sort of the point.
      </p>
      <p>
        It runs in cities all over the world the same week. A teenager in each
        one puts theirs together, and Hack Club pays for it.
      </p>
    </>
  );
}
